<template>
  <!-- {{schema}} -->
  <d-table
    :data_object="data_object"
    :getFreshData="true"
    :alwaysUpdate="true"
    :hasSearch="true"
    :searchLen="3"
    addButtonCaption="New Role"
    :editRow="true"
    :defaultModel="defaultModel"
    :fields_excluded="fields_excluded"
    :onDataReceived="onDataReceived"
    :tableReady="tableReady"
    :beforeSave="beforeSave"
    :hideAllTabFilter="true"
  />
</template>

<script>
import axios from "axios";
import errorsHandler from "../../utils/errorsHandler";
import sucessHandler from "../../utils/successHandler";
import DTable from "../../components/Table";
import * as fun from "../../plugins/common";

export default {
  name: "Roles",
  components: { DTable },
  data: () => ({
    fields_excluded: [],
    data_object: {
      object_name: "roles",
      schema_name: "roles",
      object_name_to_update: "roles",
      // db_name: "master",

      all_records: true,
      table_title: "roles",
      additional_data: [
        {
          obj_name: "v_roles",
        },
      ],
    },
    defaultModel: {
      permissions: [],
      permitted_actions: {},
    },
    users: [],
    dataLoaded: false,

    loading: false,
    rolesLoading: false,
    allRoles: [],
    portalsLoading: false,
    allPortals: [],
    tableReady: false,
    all_permissions: [],
    full_permissions: [],
  }),

  mounted() {
    var that = this;
    this.getPermissionTree();
    this.$root.$on("treeUpdated", (t) => {
      if (t.tree.k == "permissions") {
        that.full_permissions = t.tree.prepareModel();
        // console.log(that.full_permissions);
      }
    });
  },

  methods: {
    beforeSave(m) {
      console.log(m);
      // m.permissions = this.full_permissions;
    },
    getPermissionTree() {
      // this.$root.menuItems;
      var menuItems = JSON.parse(localStorage.getItem("menuItems"));
      // console.log(menuItems);
      var properties = [];
      var menuItem = "";
      var getProperties = function(prop, parentId, par) {
        Object.keys(prop).forEach((p) => {
          if (!prop[p].hidden) {
            var id = par ? par.id + "." + p : p;
            var path = id.split(".");
            if (path.length > 2) {
              var a = path.splice(path.length - 2, 2);
              id = a.join(":");
            }
            // id = id.replaceAll("properties." + menuItem, "");
            var s = {
              text: p,
              id: parentId + "." + id,
              icon: "mdi-eye",
            };
            if (!par) {
              properties.push(s);
            } else {
              par.children.push(s);
            }

            if (prop[p].properties) {
              s["children"] = [];
              getProperties(prop[p].properties, parentId, s);
            }
          }
        });
      };
      menuItems
        .filter((m) => {
          return !m.hostOnly;
        })
        .forEach((r) => {
          menuItem = "";
          var p = {
            text: r.text,
            id: r.text.toLowerCase().replaceAll(" ", "_"),
          };
          if (r.obj_name) {
            menuItem = r.object_name;
            p.children = [];
            if (r.obj_name.properties) {
              getProperties(r.obj_name.properties, p.id);

              p.children = properties;

              properties = [];
            }
          }
          if (r.children) {
            p.children = [];
            r.children.forEach((c) => {
              p.children.push({
                text: c,
                id: (p.text + "." + c.text).toLowerCase().replaceAll(" ", "_"),
              });
            });
          }
          this.all_permissions.push(p);
        });
      this.tableReady = true;
      // var data = {
      //   obj_name: "menu",
      //   folder: "structure",
      // };
      // axios
      //   .post(this.serverURL + "/get_schema", data, {
      //     withCredentials: true,
      //   })
      //   .then((response) => {
      //     response.data.forEach((r) => {
      //       var p = {
      //         text: r[0],
      //       };
      //       if (r[1] && r[1].children) {
      //         p.children = [];
      //         r[1].children.forEach((c) => {
      //           p.children.push({ text: c });
      //         });
      //       }
      //       this.all_permissions.push({ text: r[0] });
      //     });
      //     this.tableReady = true;
      //   });
    },
    onDataReceived(d) {
      d.schema.properties.permissions["v-bind"].items = this.all_permissions;
      d.additional_model.v_roles.forEach((a) => {
        if (
          !d.model.some((existingItem) => {
            return existingItem.name === a.name;
          })
        ) {
          d.model.push(a);
        }
      });

      d.model.forEach((m) => {
        if (!m.permitted_actions) {
          m.permitted_actions = {};
        }
      });

      return d;
    },
  },
};
</script>

<style scoped></style>
